const BaseModel = require('./base').default;

class Contact extends BaseModel {};

Contact.validation('contactType', { presence: true });
Contact.validation('value', { presence: true });

export default Contact;
